export enum DispersionMethodProcess {
  ORIGINATION,
  EFECTY,
  CUSTOM,
}
